import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { AuthorAvatar } from "@/components/social/AuthorLink";
import { useAuth } from "@/context/AuthContext";
import { fileUrl } from "@/lib/api";

/**
 * The avatar that sits beside a message bubble, in every private-message surface
 * (platform DMs in the dock and the Messages page, and Group Member Messages).
 *
 * It is ONE component because the three surfaces must agree on two things: whose face
 * appears next to a message, and that tapping it goes to that member's profile. Your own
 * avatar comes from the signed-in session and is deliberately not a link — nobody needs a
 * shortcut to their own profile from their own message.
 */
export function MessageAvatar({ card, mine, size = "h-7 w-7", testId }) {
  const { user } = useAuth();
  const name = mine
    ? (user?.preferred_first_name || user?.first_name || "You")
    : (card?.display_name || "Member");
  const initials = mine
    ? `${(user?.first_name || "U")[0]}${(user?.last_name || "")[0] || ""}`.toUpperCase()
    : (name[0] || "?").toUpperCase();
  const picture = mine ? user?.picture : card?.headshot_url;
  const avatar = (
    <Avatar className={`${size} shrink-0`} data-testid={testId}>
      {picture ? <AvatarImage src={fileUrl(picture)} alt={name} /> : null}
      <AvatarFallback className="bg-teal-50 text-[11px] text-teal-700">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
  if (mine) return avatar;
  return <AuthorAvatar card={card}>{avatar}</AuthorAvatar>;
}
